export default __webpack_public_path__ + "static/media/in-the-forest-ambient-acoustic-guitar-instrumental-background-music-for-videos-5718.1f262a0a.mp3";